import React from "react";

import ImagePartitionLayout from '../../layout/imagepartitionlayout/imagepartitionlayout'
import AuthenticationContainer from "../../components/AuthenticationContainer/authenticationcontainer";
import MFACodeForm from "./component/mfaOTPCodeForm";
import {MFA_SUBTITLE, MFA_VERF_TITLE, WEBSITE_TITLE} from "../../constants/appconstants";



class MFAVerification extends React.Component {
    render() {
        return (
            <ImagePartitionLayout ContentComponent={ <AuthenticationContainer  Component={<MFACodeForm/>} titleLabel={MFA_VERF_TITLE}/>}
                                  title={WEBSITE_TITLE}
                                  subtitle={
                                      ""}
            />
        );
    }
}

export default MFAVerification;



